<template>
  <div class="feedback">
    <div class="sticky">
      <div class="header">
        <img
          src="@/assets/mobile/back.png"
          alt=""
          class="back"
          @click="back()"
        />
        <div class="logo">反馈意见</div>
      </div>
    </div>
    <div class="form">
      <p class="title">您有多大可能将{{website.web_title}}推荐给朋友</p>
      <div class="score">
        <span>评分：</span>
        <el-rate v-model="form.score"></el-rate>
      </div>
      <div class="select-box" @click="drawer = true">
        <div class="select-left">
          <div class="select-type">反馈类型</div>
          <div class="select-desc" v-if="form.type">{{ form.type }}<span v-if="form.template_id">({{templatedata[templatedata.findIndex(x => x.id === form.template_id)].title}})</span></div>
        </div>
        <div class="select-right">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACASURBVHgB3ZCxCcAgEEU9J8kqmSBjWFhkBHWDpLRzJDdwEcF8IaXGswseHCd+30NOiDXLe5/QlvNWdu5vtOFImgKl1IVhORL6CgGbV+QgtdMCjkSOBIAcEUUcz1Y+FOAHoZSy5Zz3Vj7aQcA4Kqy1jlMCDtwVcOFavR0kDvyPegBHx0FJtegKCQAAAABJRU5ErkJggg=="
            alt="跳转"
          />
        </div>
      </div>
      <div  class="suggest-box">
        <textarea placeholder="请详细描述问题或建议" v-model="form.content"></textarea>
      </div>
      <el-button type="primary" style="width:100%" @click="feedbackSubmit()">提交</el-button>
    </div>
    <el-drawer
      title="选择反馈类型"
      :visible.sync="drawer"
      direction="btt"
      :show-close="false"
    >
        <div class="configbox">
            <ul class="config">
                <li v-for="(item,index) in config" :key="index" @click="selecttype(item)">
                    <p :class="form.type==item.name?'blue':''">
                        {{item.name}}
                    </p>
                    <img v-if="item.is_need_choose_category"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACASURBVHgB3ZCxCcAgEEU9J8kqmSBjWFhkBHWDpLRzJDdwEcF8IaXGswseHCd+30NOiDXLe5/QlvNWdu5vtOFImgKl1IVhORL6CgGbV+QgtdMCjkSOBIAcEUUcz1Y+FOAHoZSy5Zz3Vj7aQcA4Kqy1jlMCDtwVcOFavR0kDvyPegBHx0FJtegKCQAAAABJRU5ErkJggg=="
                        alt="跳转"
                    />
                </li>
            </ul>
            <el-button type="info" class="infobutton">取消</el-button>
        </div>
    </el-drawer>
    <el-drawer
      title="选择结果不准确的场景"
      :visible.sync="drawer1"
      direction="btt"
      :show-close="false"
      size="400px"
    >
        <div class="templatebox">
            <el-scrollbar>
                <van-radio-group v-model="form.template_id">
                    <van-cell-group>
                        <van-cell :title="item.title" clickable v-for="(item,index) in templatedata" :key="index" @click="selecttemplate(item.id)">
                            <template #right-icon>
                                <van-radio :name="item.id" />
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-radio-group>
            </el-scrollbar>
            <el-button type="info" class="infobutton" @click="drawer1=false">取消</el-button>
        </div>
    </el-drawer>
  </div>
</template>

<script>
import { feedbackConfig,feedbackSubmit } from "@/api/user";
import { getIndexData } from "@/api/index";
export default {
  data() {
    return {
      drawer1:false,
      drawer: false,
      form: {},
      config:[],
      templatedata:[],
	  website: this.$store.website,
    };
  },
  created(){
    feedbackConfig().then(res=>{
        this.config = res.data.typeList
    })
    getIndexData().then(res=>{
        this.templatedata = res.data.template
    })
  },
  methods: {
    feedbackSubmit(){
        if(!this.form.type){
            this.$message.error("反馈类型不能为空");
            return false
        }
        feedbackSubmit(this.form).then(res=>{
            if(res.code==0){
                this.$message.success(res.message);
                this.back()
            }else{
                this.$message.error(res.message);
            }
        })
    },
    selecttemplate(id){
        this.form.template_id = id
        this.$forceUpdate();
        this.drawer = false
        this.drawer1 = false
    },
    back() {
      this.$router.back();
    },
    selecttype(data){
        if(data.is_need_choose_category){
            this.form.type = data.name
            this.drawer1 = true
        }else{
            this.form.type = data.name
            this.form.template_id = ""
             this.drawer = false
        }
    }
  },
};
</script>

<style lang="less">
.feedback {
  background-color: #fff;
  min-height: 100vh;
  .sticky {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
  }
  .header {
    display: flex;
    align-items: center;
    height: 60px;
    .back {
      height: 18px;
      padding: 0 20px;
    }
    .logo {
      flex: 1 0 10%;
      img {
        width: 77px;
        margin-top: 2px;
      }
      text-align: center;
      padding-right: 30px;
    }
  }
  .form {
    padding: 0 16px;
    .score {
      margin-top: 10px;
      display: flex;
    }
    .select-box {
      cursor: pointer;
      margin: 16px 0;
      padding: 16px;
      width: 100%;
      height: 75px;
      background: #f7f7f7;
      border-radius: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .select-desc {
        font-size: 12px;
        color: #2d8af5;
      }
    }
    .suggest-box{
        background-color: #f7f7f7;
        box-shadow: none;
        border-radius: 8px;
        height: 170px;
        padding: 16px;
        margin-bottom: 20px;
        textarea{
            border: none;
            outline: none;
            width: 100%;
            height: 100%;
            background-color: transparent;
        }
    }
  }
  .configbox{
    padding: 0 32px;
    .config{
        li{
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
        }
        .blue{
            color: #2d8af5;
        }
    }
    .infobutton{
        display: block;
        width: 100%;
    }
  }
  .templatebox{
    padding: 0 32px;
    .el-scrollbar{
        height: 260px;
        .el-scrollbar__wrap{
            overflow-x: hidden;
        }
    }
    .infobutton{
        display: block;
        width: 100%;
    }
  }
}
</style>